import { useEffect, useState } from "react";

export const useCookieConsent = () => {
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    setConsent(localStorage.getItem("cookieConsent") === "true");
  }, []);

  const markConsent = () => {
    localStorage.setItem("cookieConsent", "true");
    setConsent(true);
  };

  const clearConsent = () => {
    localStorage.removeItem("cookieConsent");
    setConsent(false);
  };

  return {
    markConsent,
    clearConsent,
    didConsent: consent,
  };
};
